import { createFileRoute } from '@tanstack/react-router'
import { CanView } from '@/components/can-view'
import { SettingsMembersPage } from '@/features/settings/ui/settings-members-page'

export const Route = createFileRoute('/_authenticated/settings/members')({
	component: () => (
		<CanView permission='settings.permissions.manage'>
			<SettingsMembersPage />
		</CanView>
	),
})
